import React from "react";
import "./faqPage.scss";
import Container from "../../components/Container/Container";

const FaqPage = () => {
  return (
    <Container type="wide">
      <div className="faq-codes-list">
        <h2 className="faq-codes-list__heading">Mokymo programos ir veiklos sričių kodai</h2>
        <table className="faq-codes-list__table">
          <thead>
            <tr>
              <th>MOKYMO PROGRAMOS KODAI</th>
              <th>VEIKLOS SRIČIŲ KODAI</th>
              <th>REIKŠMĖ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>HB, H1</td>
              <td>007</td>
              <td>
                Švietimo teikėjų, vykdančių asmenų iki 18 metų ugdymą pagal formaliojo ir (ar)
                neformaliojo švietimo programas.
              </td>
            </tr>
            <tr>
              <td>HB, H2</td>
              <td>008</td>
              <td>
                Socialiniai darbuotojai, dirbantys suaugusių asmenų socialinės globos įstaigose,
                individualios priežiūros personalas
              </td>
            </tr>
            <tr>
              <td>HB, H3</td>
              <td>009</td>
              <td>
                Grožio paslaugas teikiantys darbuotojai, tiesiogiai susiję su klientų aptarnavimu,
                galintys daryti tiesioginę įtaką paslaugų vartotojų sveikatai
              </td>
            </tr>
            <tr>
              <td>HB, H4</td>
              <td>010</td>
              <td>
                Soliariumų paslaugas teikiantys darbuotojai, tiesiogiai susiję su klientų
                aptarnavimu, galintys daryti tiesioginę įtaką paslaugų vartotojų sveikatai
              </td>
            </tr>
            <tr>
              <td>HB, H5</td>
              <td>011</td>
              <td>
                Sporto klubų, baseinų, pirčių, sveikatingumo paslaugas teikiantys darbuotojai,
                tiesiogiai susiję su klientų aptarnavimu, galintys daryti tiesioginę įtaką paslaugų
                vartotojų sveikatai
              </td>
            </tr>
            <tr>
              <td>HB, H6</td>
              <td>013</td>
              <td>
                Apgyvendinimo paslaugas teikiantys darbuotojai, tiesiogiai susiję su klientų
                aptarnavimu, galintys daryti tiesioginę įtaką paslaugų vartotojų sveikatai
              </td>
            </tr>
            <tr>
              <td>HB, H7</td>
              <td>016</td>
              <td>
                Keleivinio transporto darbuotojai, aptarnaujantys keleivius (konduktoriai,
                stiuardai, traukinių palydovai ir kt. darbuotojai)
              </td>
            </tr>
            <tr>
              <td>HB, H1</td>
              <td>017</td>
              <td>
                Vaikų poilsio stovyklų, vaikų žaidimų patalpų darbuotojai, prižiūrintys vaikus
              </td>
            </tr>
            <tr>
              <td>HB, H9</td>
              <td>019</td>
              <td>
                Vandens tiekimo įmonių darbuotojai bei jų vadovai, galintys tiesiogiai daryti įtaką
                vandens saugai ir kokybei
              </td>
            </tr>
            <tr>
              <td>HBB, H10</td>
              <td>020</td>
              <td>
                Maisto tvarkymo subjektų darbuotojai, galintys daryti tiesioginę įtaką maisto saugai
                ir kokybei (išskyrus turgaviečių prekiautojus, prekiaujančius jų pačių surinktomis,
                neperdirbtomis miško gėrybėmis, namų valdoje užaugintais žemės ūkio produktais)
              </td>
            </tr>
            <tr>
              <td>HB, H11</td>
              <td>021</td>
              <td>
                Valymo paslaugas švietimo teikėjams, vykdantiems asmenų iki 18 metų ugdymą pagal
                formaliojo ir (ar) neformaliojo švietimo programas, asmens sveikatos priežiūros
                įstaigoms, socialinės globos įstaigoms, maistą tvarkantiems subjektams, kosmetikos
                gaminius gaminančioms įmonėms, grožio, soliariumų, sporto klubų, baseinų, pirčių,
                sveikatingumo, apgyvendinimo, žmogaus palaikų laikymo, paruošimo šarvoti, šarvojimo,
                kremavimo, balzamavimo paslaugų teikėjams, skalbykloms ir sauso (cheminio) valymo
                valykloms, vaikų poilsio stovyklas organizuojantiems asmenims, vaikų žaidimų
                patalpas eksploatuojantiems asmenims teikiantys darbuotojai, minėtų ūkio subjektų
                valytojai, jeigu tokie yra.
              </td>
            </tr>
            <tr>
              <td>HB, H12</td>
              <td>022</td>
              <td>
                Skalbinių priėmimą, išdavimą, skalbimą, lyginimą, lankstymą, pakavimą ir sausą
                (cheminį) valymą atliekantys darbuotojai
              </td>
            </tr>
            <tr>
              <td>HB, H13</td>
              <td>023</td>
              <td>
                Darbuotojai, kurių veikla susijusi su medicininių atliekų tvarkymu sveikatos
                priežiūros įstaigose
              </td>
            </tr>
            <tr>
              <td>HB, H14</td>
              <td>024</td>
              <td>
                Darbuotojai, kurių veikla susijusi su žmogaus palaikų laikymo, paruošimo šarvoti,
                šarvojimo, kremavimo, balzamavimo paslaugų teikimu, galintys daryti tiesioginę įtaką
                paslaugos saugai
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default FaqPage;
